import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';

export interface AddMainPageHostPayload {
  locationId: string;
  groupId: string;
  clubId: string;
  displayOrderId: string;
  hosts: {
    hostId: string;
  }[];
}

export interface DeleteMainPageHostPayload {
  recommendationId: string;
  hostId: string;
}

export interface UpdateMainPageHostPayload {
  recommendationId: string;
  hosts: { hostId: string }[];
}

const addMainPageHost = (client: AxiosInstance) => async (payload: AddMainPageHostPayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.CREATE_MAIN_PAGE_HOST, payload)).data;
};

const deleteMainPageHost = (client: AxiosInstance) => async (payload: DeleteMainPageHostPayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.DELETE_MAIN_PAGE_HOST, payload)).data;
};

const updateMainPageHost = (client: AxiosInstance) => async (payload: UpdateMainPageHostPayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.UPDATE_MAIN_PAGE_HOST, payload)).data;
};

export const mainPageHostMutations = {
  addMainPageHost,
  deleteMainPageHost,
  updateMainPageHost,
};
